import utils from "../../../utils/utils";

export default {    
    async fetchLocations(context){                
        const response = await utils.utility.fetch("api/Editor/GetTrendTweetLocations","GET", null, null);
        context.commit('setLocations',response.data);
    },
    async fetchTrendTweets(context, payload) {        
        const response = await utils.utility.fetch(`api/Editor/GetTrendTweetsByLocation?woeid=${payload.locationId}`,"GET",null,null);
        context.commit("setTrendTweets",response.data);
    },
    async fetchConnectedAccounts(context,payload) {
        const response = await utils.utility.fetch(`api/Setting/GetSocialMediaAccounts?source=${payload.source}&accountType=${payload.accountType}&pageNumber=${payload.pageNumber}&pageSize=${payload.pageSize}&sortColumn=${payload.sortColumn}&sortDirection=${payload.sortDirection}&searchText=${payload.searchText}`);        
        context.commit("setConnectedAccounts", response.data);
    },
    async deleteAccount(_,payload){
        await utils.utility.fetch("api/Setting/DeleteSocialMediaAccount","PUT",null, payload);        
    },
    async toggleReplyEnabledAccount(_,payload){
        await utils.utility.fetch("api/Setting/ToggleReplyStatusSocialMediaAccount","PUT",null, payload);        
    },
    async toggleCheckMentionEnabledAccount(_,payload){
        await utils.utility.fetch("api/Setting/ToggleCheckMentionStatusSocialMediaAccount","PUT",null, payload);        
    },
    async fetchAuthorizeUrl(context){
        const response = await utils.utility.fetch("api/Setting/GetTwitterDefinition","GET",null, null);        
        context.commit("setAuthorizeUrl",response.data);
    },
    async fetchWebhookSubscription(_,payload) {
        const response = await utils.utility.fetch(`api/Setting/GetTwitterAccountWebhookSubscription?accountId=${payload.accountId}`, 'GET', null, null);            
        return response;
    },
    async fetchPrivateKeySubscription(_,payload) {
        const response = await utils.utility.fetch(`api/Setting/GetTwitterPrivateKeySubscription?accountId=${payload.accountId}`, 'GET', null, null);            
        return response;
    },
    async togglehWebhookSubscription(_,payload) {
        await utils.utility.fetch("api/Setting/ToggleTwitterWebHookSubscription","POST",null, payload);        
    },
    async addTwitterPrivateKey(_,payload) {
        await utils.utility.fetch("api/Setting/AddTwitterPrivateKey","POST",null, payload);        
    },
}